export default __webpack_public_path__ + "static/media/contextual-chocolate@3x.240ca30f.png";